function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "40",
  viewBox: "0 0 41 40"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: ".9",
  transform: "translate(13 9)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "6.232",
  cy: "2.7",
  r: "2.25"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.226 9.72l-.99-.331a4.955 4.955 0 01-1.408-.737l-.915-.687a5.13 5.13 0 00-5.367-.485 5.686 5.686 0 00-3.163 5.012c-.03.65.392 1.234 1.017 1.412a1.35 1.35 0 001.68-1.244A3.126 3.126 0 014.7 9.918l.18-.09v1.597a17.5 17.5 0 01-.417 3.796 9.416 9.416 0 01-1.99 3.733 1.35 1.35 0 002.113 1.682 13.815 13.815 0 002.42-4.665 11.43 11.43 0 012.445 4.248 1.35 1.35 0 102.562-.853 13.81 13.81 0 00-4.111-6.268.891.891 0 01-.32-.678v-2.077l.622.466a7.65 7.65 0 002.176 1.14l1.059.353a1.35 1.35 0 001.763-1.08c.08-.67-.33-1.303-.976-1.502z"
}))));